//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../Routing/Routing.RouteObjectCollectorList.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/ObjectList.js";
let d=[[[1,"RouteControlPointList",0,"Routing.RouteObjectCollectorList",0],[1,"RouteObjectCollector",0,"Routing.RouteObjectCollector",0]],[[[],"CreateRouteControlPointListItem",{R_:{listitem:"Routing.RouteObjectCollector"}},0,0],[["jaCharx"],"SpecifyEndForm",{},1,0],[[],"PlaceEndForm",{},0,0],[[],"EditEndForm",{},0,0],[[],"RemoveEndForm",{},0,0]],[]];
SPLM.Routing.EndFormBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.EndFormBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;